import { gql } from "@/gql/__generated__";
import { HttpMethod, HttpStatusCode } from "@/utils/http";
import { useMutation } from "@apollo/client";
import { useCallback } from "react";

const CREATE_UPLOAD_URL = gql(`
  mutation CREATE_UPLOAD_URL($appVersionId: ID!) {
    appVersionUploadURL(appVersionID: $appVersionId) {
      url
    }
  }
`);

export const useUploadAppVersionArchive = () => {
  const [createUploadURL] = useMutation(CREATE_UPLOAD_URL);

  const uploadAppArchive = useCallback(
    async (appVersionId: string, archive: Blob) => {
      const createUploadURLResponse = await createUploadURL({
        variables: { appVersionId }
      });
      if (createUploadURLResponse.errors)
        throw createUploadURLResponse.errors[0];
      if (!createUploadURLResponse.data?.appVersionUploadURL.url)
        throw new Error("no upload url returned");

      const headers = new Headers();
      headers.set("Origin", window.location.host);

      const uploadResponse = await fetch(
        createUploadURLResponse.data.appVersionUploadURL.url,
        {
          headers,
          method: HttpMethod.PUT,
          body: archive
        }
      );

      if (uploadResponse.status !== HttpStatusCode.Ok) {
        throw new Error(`invalid status code: ${uploadResponse.status}`);
      }
    },
    [createUploadURL]
  );

  return uploadAppArchive;
};
